<template>
	<div class="fuwu">
		<header-view></header-view>
		<div class="top">Flority Terms of Use</div>
		<div class="content">Last updated October 31, 2026</div>
		<div class="title">1. Who we are</div>
		<div class="content">FLORITY is a digital flower-arrangement app provided by HEARD (HK) LIMITED, Unit 1, 9/F, Wo
			Hing Commercial Building, 11 Wing Wo Street, Central, Hong Kong. Contact: jm@heard.ly.</div>
		<div class="title">2. Using FLORITY</div>
		<div class="content">You can arrange flowers, choose vases, save works on your device and export personalized
			images without creating an account. Use the app lawfully and respect other people’s rights. If you are under
			the legal age to agree to these terms, a parent or guardian must agree for you.</div>
		<div class="title">3. Your creations and our assets</div>
		<div class="content">You retain rights in the original content you add. You may save and share finished
			arrangements for personal use. The app and its flower, vase and design assets remain owned by us or our
			licensors; do not resell or redistribute those assets as standalone files. Apple’s Standard EULA governs your
			App Store app license.</div>
		<div class="title">4. Optional purchases</div>
		<div class="content">Where paid plans are available, the purchase screen and Apple confirmation show the
			benefits, price, currency and duration before you pay. Payment is charged to your Apple Account only after
			Apple confirms the purchase.<br><br>Weekly and Annual plans are auto-renewing subscriptions. Cancel in your
			Apple Account subscription settings at least 24 hours before the current period ends to avoid renewal; access
			continues for the paid period. A Lifetime plan is a one-time purchase of the stated premium collection, not a
			recurring subscription.<br><br>Deleting the app does not cancel a subscription. Apple handles App Store
			billing and refund requests under its rules. Nothing here limits mandatory consumer rights.</div>
		<div class="title">5. Local works and sharing</div>
		<div class="content">Drafts and Gallery works are stored locally; FLORITY does not provide cloud backup.
			Removing the app or clearing browser/site data can remove them. Export anything you want to keep. Sharing or
			saving an image sends it only to the destination you choose, whose own terms may apply.</div>
		<div class="title">6. Availability and updates</div>
		<div class="content">We maintain and improve FLORITY, but cannot promise uninterrupted availability or recovery
			of lost local works. Features may change with updates. These terms do not exclude liability or rights that
			cannot lawfully be excluded. We will identify changes by updating the date and give additional notice where
			required.</div>
		<div class="title">Useful links</div>
		<div class="content">
			<li><a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank"
					rel="noopener">Apple Standard EULA</a></li>
			<li><a href="https://apps.apple.com/account/subscriptions" target="_blank" rel="noopener">Manage Apple
					subscriptions</a></li>
			<li><a href="https://reportaproblem.apple.com/" target="_blank" rel="noopener">Apple purchase support and
					refunds</a></li>
		</div>
		<div class="title">Contact</div>
		<div class="content">HEARD (HK) LIMITED<br>jm@heard.ly</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.fuwu {
		padding: 87px 15px 40px;

		.top {
			font-size: 28px;
			font-weight: 600;
			padding: 25px 0;
		}

		.title {
			font-size: 20px;
			margin: 20px 0;
		}

		.content {
			font-size: 13px;

			li {
				margin: 10px 0;
			}

			a {
				color: inherit;
				text-decoration: underline;
			}
		}
	}
</style>
